import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdateExamDtoPaymentTypeEnum } from '../../../common/spdCore/autogenerated/spdApiClient';
import FormRow from '../../../app/components/FormRow';

interface PaymentTypeSelectorProps {
  value: CreateUpdateExamDtoPaymentTypeEnum | undefined;
  onChange: (
    paymentType: CreateUpdateExamDtoPaymentTypeEnum | undefined,
  ) => void;
}

export const PaymentTypeSelector: React.FC<PaymentTypeSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <FormRow controlId="paymentType" label="Forma płatności">
      <Form.Select
        value={value || ''}
        onChange={e =>
          onChange(
            (e.target.value as CreateUpdateExamDtoPaymentTypeEnum) || null,
          )
        }
      >
        <option value=""></option>
        {Object.values(CreateUpdateExamDtoPaymentTypeEnum).map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
    </FormRow>
  );
};
